module.exports = __webpack_public_path__ + "static/media/img7.eff6f75f.PNG";